<template>
  <v-tooltip
    v-if="!isCallCenter"
    bottom
    :open-delay="500"
    :color="'rgba(0,0,0,0.8)'"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-sheet
        v-bind="attrs"
        :class="[`th-${metric.color}`, `${metric.key}-filial-metric`]"
        class="bar-sheet sheet-svo d-flex a-center flex-shrink-0"
        height="60"
        width="auto"
        v-on="on"
        @click="openRatingStatistics"
      >
        <div class="metric-wrapper">
          <div class="d-flex justify-center align-center">
            <font-awesome-icon class="mr-1" color="#FF9100" icon="star" />
            <template v-if="finalRating.value">
              <span class="d-block count mr-1">{{ finalRating.value }}</span>
              <font-awesome-icon
                v-if="showArrow"
                :color="arrowColor"
                :icon="arrowIcon"
              />
            </template>
            <font-awesome-icon v-else class="sync-icon" icon="sync" />
          </div>
          <span>{{ metric.title }}</span>
        </div>
      </v-sheet>
    </template>
    {{ metric.description }}
  </v-tooltip>
</template>

<script>
  import ReviewsFinalRatingStatus from '@/models/enums/ReviewsFinalRatingStatus'
  import { mapGetters } from 'vuex'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'

  export default {
    name: 'ReviewsRatingMetric',
    data () {
      return {
        metric: {
          title: 'Рейтинг',
          description: 'Рейтинг по отзывам',
        },
      }
    },
    computed: {
      ...mapGetters({
        finalRating: 'reviews/getFinalRating',
        isCallCenter: 'branches/getGlobalFilialIsCallCenter',
      }),
      showArrow () {
        return (
          !!this.finalRating.status &&
          this.finalRating.status !== ReviewsFinalRatingStatus.NotChanged
        )
      },
      arrowColor () {
        return this.finalRating.status === ReviewsFinalRatingStatus.Increased
          ? 'green'
          : 'red'
      },
      arrowIcon () {
        return this.finalRating.status === ReviewsFinalRatingStatus.Increased
          ? 'arrow-up'
          : 'arrow-down'
      },
    },
    methods: {
      openRatingStatistics () {
        if (this.userCan(CRMPermission.ViewStatistics)) {
          this.$router.push({ name: 'ratingStat' })
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.metric-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.bar-sheet {
  background-color: @color-secondary;
  padding: 12px;
  border-radius: 5px;
  margin-right: 10px;

  span {
    font-size: 11px;
    line-height: 1;
    text-align: center;
  }

  .sync-icon {
    font-size: 12px;
    animation: rotation 2s infinite;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .count {
    font-size: 24px;
    line-height: 29px;
  }

  &.sheet-svo,
  &.sheet-cto {
    &:not(.sheet-svo-last) {
      margin-right: 10px;
    }
    .count {
      font-size: 15px;
      font-weight: bold;
      white-space: nowrap;
    }
    span {
      white-space: nowrap;
    }

    &.th-empty {
      .count {
        //color: #ccc;
      }
    }

    &.th-green {
      .count {
        color: #6bad00;
      }
    }

    &.th-yellow {
      .count {
        color: #ff9100;
      }
    }

    &.th-red {
      .count {
        color: #e91e63;
      }
    }
    .media-sm({
      margin: 0 !important;

      &.sheet-svo-last {
        margin-right: 0;
      }

      .count {
        font-size: 24px;
      }

      span {
        text-align: center;
      }
    });
  }

  .media-xl({
    margin-right: 10px;
  });

  // компактный десктоп: плитки плотнее - ширина шапки отдана поиску
  .media-compact-pc({
    padding: 12px 8px;

    &,
    &.sheet-svo:not(.sheet-svo-last),
    &.sheet-cto:not(.sheet-svo-last) {
      margin-right: 6px;
    }
  });
}
</style>
